<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>动态创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/industry')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->

      <el-form
        :model="formData"
        :rules="rules"
        label-width="110px"
        ref="formData"
      >
        <el-form-item label="标题" prop="title" required>
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="是否来自公众号" prop="pushMp" required>
          <el-select
            v-model="formData.pushMp"
            placeholder="请选择"
            @change="pushMpChange"
          >
            <el-option
              v-for="item in pushMpOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="公众号地址"
          prop="mpUrl"
          required
          v-if="formData.pushMp == '1'"
        >
          <el-input type="textarea" v-model="formData.mpUrl"></el-input>
        </el-form-item>
        <el-form-item label="缩略图" required>
          <el-upload
            accept="image/*"
            class="upload-demo"
            action="/"
            multiple
            :on-change="handleChange"
            :on-remove="handleRemove"
            :http-request="uploadFn"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="内容" required v-if="formData.pushMp == '2'">
          <MyEditor ref="editor" />
        </el-form-item>

        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>创建</span>
          </el-button>
          <!-- <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <span>重置</span>
          </el-button> -->
        </div>
      </el-form>

      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { uploadFile, addAdvertise } from '@/api/advertising'
import MyEditor from './components/MyEditor.vue'
export default {
  components: { MyEditor },
  data() {
    return {
      fileList: [],
      formData: {
        title: '',
        content: '',
        status: 1,
        pushMp: '2',
        mpUrl: '',
        type: '2',
        thumbnail: ''
      },
      rules: {
        title: [{ required: true, message: '标题必填', trigger: 'blur' }],
        mpUrl: [
          { required: true, message: '来自公众号地址必填', trigger: 'blur' }
        ]
      },
      pushMpOptions: [
        { value: '1', label: '是' },
        { value: '2', label: '否' }
      ]
    }
  },

  methods: {
    pushMpChange(el) {
      if (el == 2) {
        this.mpUrl = ''
      }
    },
    uploadFn(parma) {
      console.log(parma.file)
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      this.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.thumbnail = res.data.uploadUrl

          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.fileList = []
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.$loading().close()
        }
      })
      // setTimeout(() => {
      //   this.$loading().close()
      // }, 1500)
    },

    //移除文件
    handleRemove() {
      this.formData.thumbnail = ''
    },
    //超限制
    handleExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.warning('目前只能上传一个包')
    },
    handleChange(file) {
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.fileList = []
        return
      }
    },
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    // 重置
    clearFn() {
      this.$refs.formData.resetFields()
    },
    // 创建
    submitFn() {
      // 富文本类型

      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.formData.thumbnail == '') {
            this.$message.error('请上传缩略图')
            return
          }
          if (this.formData.pushMp == '2') {
            this.formData.content = this.$refs.editor.html
            let text = this.getText(this.formData.content)
            let validateValue = this.isNull(text)
            console.log(this.isNull(text)) // true表示判空  false表示不为空
            if (validateValue) {
              this.$message({
                message: '内容不能为空',
                type: 'error'
              })
              return
            }
          }
          console.log(this.formData, '文件创建')
          if (this.submited) return
          this.$loading({
            text: '文件添加中'
          })
          // let infos = JSON.parse(JSON.stringify(this.formData))

          // if (!this.formData.status) {
          //   this.formData.status = 1
          // }
          console.log(this.formData)
          addAdvertise(this.formData).then((res) => {
            console.log(res.data, '创建')
            if (res.code == 200) {
              this.submited = true
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          })
          setTimeout(() => {
            this.$loading().close()
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// .create {
//   .button-group {
//     display: flex;
//     justify-content: center;
//     .form-button {
//       margin: 0 20px;
//     }
//   }
// }
</style>
